import DeleteIcon from '@mui/icons-material/Delete';
import { ButtonBase, Grid, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import randomColorGenerator from '../../Utils/utils';
const TrackedMission = ({ trackedmission }) => {
    TrackedMission.propTypes = {
        trackedmission: PropTypes.any,
    };
    return (
        <ButtonBase
            sx={{
                width: '100%',
                height: '100%',
                backgroundColor: randomColorGenerator(),
                borderRadius: '3px',
                padding: '3px 18px',
                marginBottom: '4px',
            }}
        >
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography
                    className="fw-bold text-muted"
                    fontSize={14}
                >{trackedmission?.titre}+ {trackedmission._id}</Typography>
                <IconButton
                    aria-label="delete"
                    size="small"
                >
                    <DeleteIcon />
                </IconButton>
            </Grid>
        </ButtonBase>
    );
};

export default TrackedMission;
